import { NavLink } from "react-router-dom";

const NavBar = () => {
  const styles = "min-w-20 px-4 py-2 focus:bg-lui-persian focus:bg-opacity-20 justify-center items-center gap-x-3";
  const activeStyle = "font-semibold bg-transparent border-b-2 border-b-lui-persian";

  return (
    <nav className="nav mb-2">
      <div className="flex border-b-lui-silver border-b-[1px]">
        <NavLink
          to="/csd-calculator"
          className={({ isActive, isPending }) =>
            isPending ? "pending" : isActive ? `${activeStyle} ${styles}` : styles
          }
        >
          CSD Fee Calculator
        </NavLink>
        <NavLink
          to="/cross-lease-csd-calculator"
          className={({ isActive, isPending }) =>
            isPending ? "pending" : isActive ? `${activeStyle} ${styles}` : styles
          }
        >
          Cross Lease CSD Fee Calculator
        </NavLink>
        <NavLink 
          to="/unit-csd-calculator"
          className={({ isActive, isPending }) =>
            isPending ? "pending" : isActive ? `${activeStyle} ${styles}` : styles
          }
        >
          Unit CSD Fee Calculator
        </NavLink>
        <div className="hidden">
          <span className="min-w-20 px-4 py-2 focus:bg-lui-persian focus:bg-opacity-20 justify-center items-center gap-x-3"></span>
          <span className="font-semibold bg-transparent border-b-2 border-b-lui-persian"></span>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
